import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, HostBinding, Input, OnDestroy, Optional, Self, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { MatChipSelectionChange } from '@angular/material/chips';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';

@Component({
  selector: 'sit-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
  providers: [
    { provide: MatFormFieldControl, useExisting: ChipsComponent }],
})
export class ChipsComponent implements MatFormFieldControl<number>, ControlValueAccessor, OnDestroy {
  static nextId = 0;

  // LIMIT = 3;
  @HostBinding() id = `sit-chips-${ChipsComponent.nextId++}`;
  @Input() options: any[];
  @Input() placeholder: string;

  selectedChipValue: number | null = null;

  @Input()
  get value(): number | null {
    return this.selectedChipValue;
  }
  set value(val: number) {
    this.selectedChipValue = val;
    this.stateChanges.next(); // Notifies when a value changes
  }

  stateChanges = new Subject<void>();
  focused = false;

  @HostBinding('class.floating')
  get shouldLabelFloat() {
    return true;
  }

  autofilled?: boolean = false;
  controlType?: string = "sit-chips";
  empty: boolean;
  @Input() 'aria-describedby': string;
  errorState: boolean;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  private _required = false;
  @Input()
  get required() {
    return this._required;
  }
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  private onChange: (value: any) => void;
  private onTouched: () => void;


  onSelectionChange(event: MatChipSelectionChange): void {
    if (event.selected) {
      this.selectedChipValue = event.source.value;
    } else {
      this.selectedChipValue = null;
    }
    this.stateChanges.next();
    if (this.onChange) {
      this.onChange(this.selectedChipValue);
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }


  onContainerClick(event: MouseEvent): void {
    return;
  }

  setDescribedByIds(ids: string[]) { return; }

  constructor(
    @Optional() @Self() public ngControl: NgControl,
  ) {

    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }

  }
  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.value = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.stateChanges.next();
  }
}
